import React from 'react';
import { Modal, Descriptions } from 'antd';
import moment from 'moment';

const statusMap = {
  0: 'Đang xử lý',
  1: 'Chờ thanh toán',
  2: 'Uỷ quyền',
  3: 'Đã thu tiền',
  4: 'Đã hoàn tiền',
  5: 'Đã hủy',
  6: 'Đã voided',
};

const colorMap = {
  0: 'orange',
  1: 'orange',
  2: 'blue',
  3: 'green',
  4: 'purple',
  5: 'red',
  6: 'red',
};

function ViewDepositModal({ open, deposit, onClose }) {
  if (!deposit) return null;

  return (
    <Modal
      open={open}
      title={`Thông tin đặt cọc: ${deposit?.id || ''}`}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Descriptions bordered column={1} size="middle">
        <Descriptions.Item label="Mã đặt cọc">{deposit?.id}</Descriptions.Item>

        <Descriptions.Item label="Mã đặt xe">
          {deposit?.book_code}
        </Descriptions.Item>

        <Descriptions.Item label="Tên khách hàng">
          {deposit?.book?.cstm_name ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Số tiền đặt cọc">
          {`${deposit?.deposit_amount?.toLocaleString('vi-VN')} ${
            deposit?.currency ?? 'VND'
          }`}
        </Descriptions.Item>

        <Descriptions.Item label="Ngày đặt cọc">
          {deposit?.deposit_date
            ? moment(deposit?.deposit_date).format('DD/MM/YYYY HH:mm')
            : '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Phương thức">
          {deposit?.payment_method ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Trạng thái">
          <span style={{ color: colorMap[deposit?.status] ?? 'black' }}>
            {statusMap[deposit?.status] ?? 'Không xác định'}
          </span>
        </Descriptions.Item>

        <Descriptions.Item label="Ngày hoàn tiền">
          {deposit?.refund_date
            ? moment(deposit?.refund_date).format('DD/MM/YYYY HH:mm')
            : '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Số tiền hoàn">
          {deposit?.refund_amount
            ? deposit?.refund_amount.toLocaleString('vi-VN')
            : '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Phương thức hoàn">
          {deposit?.refund_method ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item label="Ghi chú">
          {deposit?.note ?? '-'}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}

export default ViewDepositModal;
